<template>
    <el-dialog
            :visible.sync="dialogVisible"
            width="850px"
            height="100px"
            :show-close="false"
            :before-close="handleClose"
            class="a_modal"
            style="vertical-align: center;: #FFF9F3">
        <div style="margin-top: -30px; ">

            <el-row>
                <el-col :span="12">
                    <span style="color: cornflowerblue; font-size: 18px">创建新工单</span>
                </el-col>
                <el-col :span="12">
                    <div align="right" style="margin-top: -5px">
                        <el-row>
                            <el-button type="success" size="small" @click.stop="enterClick">确定</el-button>
                            <el-button type="danger" size="small" @click.stop="cancelClick">取消</el-button>
                        </el-row>
                    </div>
                </el-col>
            </el-row>

            <div style="width: 100%; height: 0px; margin-top: 15px;border:1px dashed gainsboro"></div>

            <el-scrollbar style="height: 450px" wrap-class="list" wrap-style="color: red;"
                          view-style="font-weight: bold;" view-class="view-box" :native="false">
                <div style="margin-top: 20px" class="subjectList">
                    <el-form ref="form" :rules="rules" :model="form" label-width="12%">
                        <el-form-item label="标题" prop="title">
                            <el-input placeholder="请填写标题" v-model="form.title" clearable
                                      style="width: 82%"></el-input>
                        </el-form-item>
                        <el-form-item label="发生日期" prop="date">
                            <el-row>

                                <el-date-picker style="width: 82%"
                                                v-model="form.date"
                                                type="date"
                                                placeholder="选择日期">
                                </el-date-picker>
                            </el-row>
                        </el-form-item>


                        <el-form-item label="门店" prop="store">
                            <el-select v-model="form.store" clearable filterable placeholder="请选择"
                                       style="width: 82%" v-on:change="getServiceProviderList">
                                <el-option
                                        v-for="item in form.storeArray"
                                        :key="item.store_id"
                                        :label="item.store_name"
                                        :value="item.store_id">
                                    <span style="float: left">{{ item.store_name }}</span>
                                    <!--<span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>-->
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="服务厂商" prop="account_id">
                            <el-select v-model="form.account_id" clearable filterable placeholder="请选择"
                                       style="width: 82%">
                                <el-option
                                        v-for="item in form.providerArray"
                                        :key="item.account_id"
                                        :label="item.provider_name"
                                        :value="item.account_id">
                                    <span style="float: left">{{ item.provider_name }}</span>
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="详情说明">
                            <el-input style="max-width: 82%; width: 82%"
                                      type="textarea"
                                      :autosize="{ minRows: 4, maxRows: 10}"
                                      placeholder="请填写详情"
                                      v-model="form.comments">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="联系方式">
                            <el-input placeholder="请填写联系方式" v-model="form.phone" clearable
                                      style="width: 82%"></el-input>
                        </el-form-item>
                        <el-form-item label="照片">
                            <el-upload
                                    action="https://api.retailstore365.com:15041/uploadphoto"
                                    :http-request="uploadFun"
                                    list-type="picture-card"
                                    :show-file-list="true" multiple
                                    :on-preview="handlePictureCardPreview"
                                    :on-success="handleImgSuccess"
                                    :before-upload="beforeImgUpload"
                                    :on-remove="handleRemove"
                                    :file-list="fileList">
                                <i class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>


                    </el-form>

                </div>
            </el-scrollbar>
        </div>
    </el-dialog>
</template>

<script>
    import http from '../../../APIService/http'

    export default {
        props: {
//            form: {
//                type: Object,
//                default: () => {
//
//                }
//
//            },
        },
        components: {},
        data() {
            return {
                fileList: [],

                dialogVisible: false,

                rules: {
                    title: [
                        {required: true, message: '请填写标题', trigger: 'blur'},
                    ],
                    date: [
                        {type: 'date', required: true, message: '请选择日期', trigger: 'change'}
                    ],
                    store: [
                        {required: true, message: '请选择门店', trigger: 'change'}
                    ],
                    account_id: [
                        {required: true, message: '请选择服务厂商', trigger: 'change'}
                    ],
                },

                form: {
                    date: '',
                    title: '',
                    account_id: [],
                    providerArray: [],
                    store: [],
                    storeArray: [],
                    comments: '',
                    phone: '',
                    picArray: [],

                }
            }
        },
        computed: {},
        created() {
//            this.getAccountData()
//            this.getServiceTypeData()
            this.getStoreListByProvider()
        },
        methods: {
            async saveLogbookTicket() {

                this.$emit('openLoading')

                var obj = this.$store.getters.getUser
                var service_provider_tenant_id = ''
                for (var i = 0; i < this.form.providerArray.length; i++) {
                    var dic = this.form.providerArray[i]
                    if (dic.account_id == this.form.account_id) {
                        service_provider_tenant_id = dic.linked_tenant
                    }
                }


                let data = {
                    tenant_id: obj.tenant_id,
                    user_id: obj.user_id,
                    service_provider_tenant_id: service_provider_tenant_id,
                    store_id: this.form.store,
                    account_id: this.form.account_id,
                    contents : {
                        title : this.form.title,
                        date : this.form.date,
                        comments : this.form.comments,
                        user_id : obj.user_id,
                        phone : this.form.phone,
                        key : '',
                        account_id : this.form.account_id,
                        service_worker : '',
                        photos : this.form.picArray
                    }
                }
                try {

                    await http.post('/wapi/v1/saveLogbookTicket', data).then(res => {
                        if (res.success) {
//                            this.form.providerArray = res.data
                            this.dialogVisible = false
                            this.$emit('initData')
                        }
                    })

                } catch (err) {
                    this.error()
                }

            },
            async getStoreListByProvider() {

                var obj = this.$store.getters.getUser

                let data = {
                    tenant_id: obj.tenant_id,
                    user_id: obj.user_id
                }
                try {

                    await http.post('/wapi/v1/getStoreListByProvider', data).then(res => {
                        if (res.success) {
                            this.form.storeArray = res.data
                        }
                    })

                } catch (err) {
                    this.error()
                }

            },
            async getServiceProviderList() {

                var obj = this.$store.getters.getUser

                let data = {
                    tenant_id: obj.tenant_id,
                    store_id: this.form.store
                }
                try {

                    this.form.providerArray = []
                    await http.post('/wapi/v1/getServiceProviderList', data).then(res => {
                        if (res.success) {
                            this.form.providerArray = res.data
                        }
                    })

                } catch (err) {
                    this.error()
                }

            },

            showDialog() {
                this.form.title = ""
                this.form.date = ""
                this.form.comments = ''
                this.form.phone = ''

                this.form.account_id = []
                this.form.store = []
                this.fileList = []
                this.form.picArray = []
                this.dialogVisible = true
            },

//            info(index, row) {
//                this.$router.push({
//                    path: '/workOrderInfo',
////                    query: {
////                        type: 1,
////                        ticket_id: row.ticket_id,
////                        store_name: row.store_name,
////                        address: row.address
////                    }
//                })
//            },
            handleClose(done) {
                // this.$confirm('确认关闭？')
                //     .then(_ => {
                //         done();
                //     })
                //     .catch(_ => {});
                done();
                // this.$forceUpdate()
            },
            enterClick() {


                if (this.form.title.replace(/\s*/g, "") == "") {
                    this.$message.error('请输入标题');
                    return
                }
                if (this.form.date == "") {
                    this.$message.error('请选择发生日期');
                    return
                }
                if (this.form.store.replace(/\s*/g, "") == "") {
                    this.$message.error('请选择门店');
                    return
                }
                if (this.form.account_id.replace(/\s*/g, "") == "") {
                    this.$message.error('请选择服务厂商');
                    return
                }

//                this.dialogVisible = false
                this.saveLogbookTicket()

            },

            cancelClick() {
                this.form.title = ""
                this.form.date = ""
                this.form.account_id = ""
                this.form.comments = ''
                this.form.store = ""
                this.form.phone = ''

                this.fileList = []
                this.form.picArray = []
                this.dialogVisible = false

            },


            uploadFun(param) {

                var self = this
                var data = new FormData(); //创建form对象
                data.append('file', param.file);
                data.append('reference_obj', 'CLIENT');
                data.append('reference_id', 'com.saasyun.android');
                data.append('credential', '58f09f86-694c-472d-bb63-64f9be093fd2');
                data.append('username', this.$store.getters.getUser.username);
                data.append('tenant_id', this.$store.getters.getUser.tenant_id);
                data.append('user_id', this.$store.getters.getUser.user_id);
                data.append('category', 'USER');
                data.append('size', '300');

                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };  //添加请求头
                http.post(param.action, data, config)//
                    .then(response => {
                        if (response.success) {

                            var s3filename = response.data.s3filename
                            self.form.picArray.push(s3filename)
                        }
                    })
                    .catch(({err}) => {
                        this.lengthoading = false
                    })
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
                var s3filename = file.response.data.s3filename
                this.form.picArray.remove(s3filename);
            },
            handlePictureCardPreview(file) {
                this.$emit('showImageAction', {
                    showImageUrl: file.url,
                    showImage: true
                })
            },
            // 上传图片成功
            handleImgSuccess(res, file) {

                if (res.success) {

                } else {
                    this.error(res.message)
                }
            },
            // 上传图片前的验证
            beforeImgUpload(file) {

                const isPic = file.type === 'application/x-jpg' || file.type === 'image/jpeg' || file.type === 'application/x-png' || file.type === 'image/png'
//                const isLt20M = file.size / 1024 / 1024 < 20

                if (!isPic) {
                    this.error('上传图片只能是 jpg 或png 格式!')
                }
//                if (!isLt20M) {
//                    this.error('上传图片大小不能超过 20MB!')
//                }
                return isPic
            },

        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';


</style>
<style scoped>

    .subjectList > > > .el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/dialog/addService.vue